/* @flow */
/* eslint-env es6,browser */

import * as u from '../utils';
import {_openxad2} from './openx2';

/**
 * @class Implements openx ad server functionality for
 *        loading multiple ads with single jsonp API call
 * @exports adserver/openx2m
 * @requires {@link module:utils}
 * @requires {@link module:adserver/openx2}
 */
class _openxad2m extends _openxad2 {
  _name: string;
  _urlLimit: number;
  constructor() {
    super();
    this._name = 'openx2m';
    this._urlLimit = 700;
  }

  _preloadJS() { /* dummy func to avoid preloading */ }

  _loadAdsInBatch(posList: Array<string>, o: Object, customVars: Object) {
    let qParams = this._getOpenxParams(), cVars = {};
    posList.forEach(pos => {
      qParams = u.extend(true, {}, (o && o[pos]) ? o[pos]._QP : {}, qParams);
      cVars[pos] = this._getCustomVars(pos, o, customVars);
    });
    this._fetchAdsAsync(posList, cVars, qParams);
  }

 _getBatchSize(posList: Array<string>, o: Object) {
    let qParams = u.param(this._getOpenxParams());
    let index = posList.findIndex( pos => {
      if (o && o[pos]) {
        qParams += u.param(o[pos]._QP);
      }
      return qParams.length > this._urlLimit;
    });
    return (index < 0) ? posList.length : index + 1;
  }

  /**
   * Loads openx static using adloader
   * @param {Array<string>} posList - position list array
   * @param {Object.<string, hbPosData>} o - header bidding return object
   * @param {Object} customVars - custom variable to be populated inside iframe
   */
  loadAds(posList: Array<string>, o: Object, customVars: Object) {
    //do not modify the passed posList
    posList = (posList || []).slice();
    while(posList.length > 0) {
      this._loadAdsInBatch(posList.splice(0, this._getBatchSize(posList, o)), o, customVars);
    }
  }

}

let openx2m = new _openxad2m();
export {openx2m, _openxad2m};
